<template>
    <div class="teach-overview">
        <div class="teach-overview-top">
            <div class="title">学科资源分析</div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="teach-region">
            <div class="left-content">
                <div class="num">65w</div>
                <div class="text">上传总量</div>
            </div>
            <div class="right-content">
                <tbody>
                    <tr v-for="(subject, index) in dataList" :key="subject.subjectId" class="table-content">
                        <td class="rank">{{ `NO.${index + 1}&#32${subject.name}` }}</td>
                        <td>{{ subject.count }}</td>
                    </tr>
                </tbody>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
<script>
export default {
    name: 'teach-overview',
    components: {},
    data() {
        return {
            //是否选择活动评审
            isSelectReview: true,
            dataList: [
                { name: '小学语文', count: 6954774 }, { name: '小学数学', count: 6954774 }, { name: '小学英语', count: 6954774 }, { name: '自然与科学', count: 6954774 }, { name: '小学美术', count: 6954774 }
            ],
            studioList: [
                {
                    name: "王明名师工作室",
                    number: 51145,
                    typeName: "活跃度"
                },
                {
                    name: "朱志英名师工作室",
                    number: 49523,
                    typeName: "活跃度"
                },
                {
                    name: "刘小锋名师工作室",
                    number: 43864,
                    typeName: "活跃度"
                },
                {
                    name: "张继德名师工作室",
                    number: 36785,
                    typeName: "活跃度"
                },
                {
                    name: "赵范名师工作室",
                    number: 35268,
                    typeName: "活跃度"
                }
            ],
            reviewList: [
                {
                    name: "全区师生阅读推广活动",
                    number: 59640,
                    typeName: "作品数"
                },
                {
                    name: "区小数首届网络画板...",
                    number: 54623,
                    typeName: "作品数"
                },
                {
                    name: "上虞区小学英语教案...",
                    number: 51145,
                    typeName: "作品数"
                },
                {
                    name: "上虞区小学语文教案...",
                    number: 46389,
                    typeName: "作品数"
                },
                {
                    name: "全区第二届短视频征...",
                    number: 43316,
                    typeName: "作品数"
                }
            ],
            phaseList: [
                {
                    value: 500,
                    name: '小学',
                    number: 50
                },
                {
                    value: 25,
                    name: '初中',
                    number: 250
                },
                {
                    value: 25,
                    name: '高中',
                    number: 250
                }
            ]
        }
    },
    methods: {},
    mounted() {

    },
}
</script>
<style lang="scss" scoped>
@font-face {
    font-family: MaravaleExpanded;
    src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
}

.teach-overview {
    width: 100%;
    height: 305px;
    padding: 0 15px;
    border: 1px solid #053882;
    // background: rgba(6,17,52,0.8);
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;

    .teach-overview-top {
        position: relative;
        text-align: center;
        margin-bottom: 15px;

        .title {
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }

        .title-bg {
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .teach-region {
        width: 100%;
        height: calc(100% - 66px);
        display: flex;

        .left-content {
            height: 100%;
            width: 30%;
            background-image: url("~@/assets/images/shangchuanbg.png");
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            background-size: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-right: 5%;

            .num {
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }

            .text {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #6EA0D3;
            }
        }

        .right-content {
            .table-content {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #6EA0D3;
                line-height: 44px;
                text-align: left;

                .rank {
                    font-size: 14px;
                    // font-family: DingTalk JinBuTi;
                    font-weight: 400;
                    color: #6EA0D3;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    height: 30px;
                    padding: 2px;
                    text-align: left;
                    background-size: 100% 100%;
                    background: url('../../../assets/images/sydataboard/four.png') no-repeat;
                    margin-right: 6vh;
                }

                // .one {
                //     background: url('../../../assets/images/sydataboard/one.png') no-repeat;
                //     color: #FF5B74;
                // }

                // .two {
                //     background: url('../../../assets/images/sydataboard/two.png') no-repeat;
                //     color: #CEB151;
                // }

                // .three {
                //     background: url('../../../assets/images/sydataboard/three.png') no-repeat;
                //     color: #27CDE6;
                // }
            }
        }
    }

    .top-left {
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }

    .top-right {
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }

    .left-bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }

    .right-bottom {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}</style>